import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function Privacy() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Privacy policy"} />
      <MarkdownBlock markdown={TextBlocks.PRIVACY_POLICY_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
